﻿var abp = abp || {};
var _notificationService = _notificationService || {};
(() => {
  abp.notify.success = (message, title, options) => {
      _notificationService.success(message);
  };

  abp.notify.info = (message, title, options) => {
      _notificationService.info(message);
  };

  abp.notify.warn = (message, title, options) => {
      _notificationService.warn(message);
  };

  abp.notify.error = (message, title, options) => {
      _notificationService.error(message);
  };
})();
